import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import DatePicker from 'react-datepicker';
import { format, isValid, parse } from 'date-fns';
import ru from 'date-fns/locale/ru';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from '../../../components/headerBtn/headerBtn';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from '../../../types/interfaces';
import Loader from '../../../components/custom/loader/loader';
import LimitSelect from '../../../components/custom/limitSelect/limitSelect';
import Pagination from '../../../components/pagination/pagination';
import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetSimplifiedProjectsList } from '../../../redux/action/projects/actionProjects';
import { IAddContractInputValue, IBudgetPos, ICoefficientFilterInputValues, IEditContractInputValue, } from '../../../types/contractsInterface';
import Select from '../../../components/custom/select/select';
import {
    actionActivateCoefficients,
    actionAddCoefficient,
    actionBulkDeleteCoefficients,
    actionDeleteCoefficient,
    actionEditCoefficient,
    actionGetBudgetPoses,
    actionGetCoefficientList,
} from '../../../redux/action/contracts/actionContracts';
import { actionGetServiceTypes, actionGetServiceTypesSelect, } from '../../../redux/action/easymerch/actionServiceTypes';

import Checkbox from '../../../assets/images/checkbox.png';
import Delete from '../../../assets/images/delete.png';
import Edit from '../../../assets/images/edit.png';
import toast, { Toaster } from 'react-hot-toast';
import ToastPopup from '../../../components/custom/toastPopup/toastPopup';
import { generateStyles } from '../../../utils/generateToastStyles';
import { reducerCoefficientFilterInputValues, reducerSetRequestStatus, reducerSetRequestStatusMessage } from '../../../redux/reducer/contracts/reducers/reducerCoefficientList';
import { formatReports } from '../../../utils/formatReports';
import styles from '../../../components/table/contracts/contracts.module.scss';
import '../../../components/table/table.scss';

const initialAddInputState = {
    project: null,
    pos: null,
    coefficient: '',
    startDate: null,
    endDate: null,
};

const initialEditInputState = {
    ...initialAddInputState,
    contractId: 0,
};

const activatedFilterOptions = [
    { value: '', label: 'Все' },
    { value: 'true', label: 'Да' },
    { value: 'false', label: 'Нет' },
];

const requestStatusOptions = [
    {
        status: 200,
        successMessage: 'Новый коэффициент успешно добавлен!',
    },
    {
        status: 0,
        errorMessage: 'При добавлении произошла ошибка!',
    },
    {
        status: 202,
        successMessage:
            'Файл с коэффициентами проектов успешно доблен в очередь обработки! ' +
            'Результат загрузки можно посмотреть в разделе Выгрузки - Загрузка шаблонов',
    },
    {
        status: 204,
        successMessage: 'Коэффициент успешно удален!',
    },
    {
        status: 400,
        errorMessage: 'Запись с таким проектом и периодом уже существует',
    },
    {
        status: 404,
        errorMessage: 'Запрощенный ресурс не найден',
    },
    {
        status: 'deleteError',
        errorMessage: 'При удалении произошла ошибка!',
    },
    {
        status: 'invalidCoefficient',
        errorMessage: 'Некорректное значение коэффициента',
    },
    {
        status: 'noData',
        errorMessage: 'Необходимо заполнить недостающие значения!',
    },
    {
        status: 'updateSuccess',
        successMessage: 'Данные куспешно обновлены!',
    },
    {
        status: 'updateError',
        errorMessage: 'При обновлении данных произошла ошибка!',
    },
    {
        status: 'activateSuccess',
        successMessage: 'Коэффициенты успешно активированы!',
    },
    {
        status: 'activateError',
        errorMessage: 'При активации коэффициентов произошла ошибка!',
    },
    {
        status: 'bulkDeleteSuccess',
        successMessage: 'Коэффициенты успешно удалены!',
    },
    {
        status: 'bulkDeleteError',
        errorMessage: 'При удалении коэффициентов произошла ошибка!',
    },
    {
        status: 'validationError',
        errorMessage: '',
    },
    {
        status: 'noSelection',
        errorMessage: 'Необходимо выбрать элементы списка!',
    },
];

const AdminContractsInfoSection = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();

    const { simplifiedProjectsById, simplifiedProjectsOptions } = useSelector(
        (state: any) => state.projects.projects,
    );
    const { list, requestStatus, requestStatusMessage, filterInputValues, poses, count } = useSelector(
        (state: any) => state.contracts.coefficients,
    );
    const {
        selectContactById,
        offset,
        limit: limitServiceTypes,
    } = useSelector((state: any) => state.easymerch.serviceTypes);

    const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

    const canEditCoefficients =
        claims.includes('admin') || claims.includes('contracts:budget:coefficient:update');
    const canActivateCoefficients =
        claims.includes('admin') || claims.includes('contracts:budget:coefficient:activate');
    const canBulkSelect = canEditCoefficients || canActivateCoefficients;

    const actualLimit =
        JSON.parse(localStorage.getItem('pageLimit') as string) ||
        limitServiceTypes;

    const { isOpenSidebar } = useSelector(
        (state: IUserOptions) => state.user.user,
    );
    const [isPending, setIsPending] = useState<boolean>(false);
    const [isInputChange, setIsInputChange] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [startPage, setStartPage] = useState<number>(1);

    const buttonsContainerRef = useRef<any>(null);

    const [overflowedBtnsCount] = useState<number>(0);
    const [isOpenGroupBtn] = useState<boolean>(false);

    // const [contractInputValues, setContractInputValues] =
    //   useState<IContractInputValue>({
    //     projects: [],
    //     startDate: null,
    //     endDate: null,
    //   });

    const [addContractInputValues, setAddContractInputValues] =
        useState<IAddContractInputValue>(initialAddInputState);

    const [editContractInputValues, setEditContractInputValues] =
        useState<IEditContractInputValue>(initialEditInputState);

    const [editRowId, setEditRowId] = useState<number | null>(null);
    const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
        useState<boolean>(false);
    const [isCheckedRows, setIsCheckedRows] = useState<{ [key: number]: boolean }>(
        {},
    );
    const [selectedCoefficientIds, setSelectedCoefficientIds] = useState<
        { id: number }[]
    >([]);

    const budgetPosesOptions = useMemo(
        () =>
            (poses || []).map((pos: IBudgetPos) => ({
                value: pos.id,
                label: pos.name,
            })),
        [poses],
    );

    const projectFilterOptions = useMemo(
        () => [{ value: '', label: 'Все' }, ...(simplifiedProjectsOptions || [])],
        [simplifiedProjectsOptions],
    );

    const coefficientsList = useMemo(
        () => (id && list && list[id] ? list[id] : []),
        [id, list],
    );

    const hasSelectedCoefficients = selectedCoefficientIds.length > 0;

    const availableButtons = [
        {
            claims: [],
            component: (
                <HeaderBtn
                    content='Вернуться к списку'
                    purpose='navigateToContractsList'
                    modalTitle='Возврат к списку контрактов'
                />
            ),
        },
        {
            claims: ['admin', 'contracts:budget:coefficient:import'],
            component: (
                <HeaderBtn
                    content='Загрузка коэффициентов бюджета'
                    purpose='importCoefficients'
                    modalTitle='Загрузка коэффициентов бюджета'
                    selectId={getContractId()}
                />
            ),
        },
    ];

    const filteredAvailableButtons = availableButtons.filter((btn: any) => {
        return btn.claims?.length > 0
            ? btn.claims.filter((claim: any) => claims.includes(claim)).length > 0
            : true;
    });

    const fetchCoefficients = useCallback(
        (page = 1, limit = actualLimit) => {
            if (!id) {
                return Promise.resolve();
            }

            setIsPending(true);
            return dispatch(actionGetCoefficientList(id, limit, page)).then(() => {
                setIsPending(false);
            });
        },
        [id, dispatch, actualLimit],
    );

    const resetPages = () => {
        setCurrentPage(1);
        setStartPage(1);
    };

    const handleChange = (newLimit: number, newPage: number) => {
        fetchCoefficients(newPage, newLimit);
        localStorage.setItem('pageLimit', JSON.stringify(newLimit));
    };

    const handleChangeLimits = (option: { value: number }) => {
        handleChange(option.value, 1);
        resetPages();
    };

    useEffect(() => {
        dispatch(actionGetSimplifiedProjectsList(1000, 1)).then(() => {
            setIsPending(false);
        });
    }, [dispatch]);

    useEffect(() => {
        if (id) {
            resetPages();
            fetchCoefficients(1, actualLimit);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        const handleDocumentClick = (event: MouseEvent) => {
            if (!id) {
                return;
            }

            if ((event.target as HTMLElement).closest('.pagination')) {
                return;
            }

            resetPages();
            fetchCoefficients(1, actualLimit);
            setIsInputChange(false);
        };

        if (isInputChange) {
            document.addEventListener('click', handleDocumentClick);

            return () => {
                document.removeEventListener('click', handleDocumentClick);
            };
        }

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [id, isInputChange, fetchCoefficients, actualLimit]);

    useEffect(() => {
        if (id) {
            dispatch(actionGetBudgetPoses(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        requestStatusOptions.forEach(
            (option: {
                status: number | string;
                successMessage?: string;
                errorMessage?: string | undefined;
            }) => {
                if (requestStatus === option.status) {
                    const message =
                        requestStatus === 'validationError' || requestStatus === 400
                            ? requestStatusMessage || option.errorMessage
                            : option.successMessage || option.errorMessage;

                    if (!message) {
                        return;
                    }

                    toast.dismiss();
                    toast(
                        (t) => (
                            <ToastPopup
                                title={message}
                                isSuccess={Boolean(option.successMessage)}
                                toast={toast}
                                t={t}
                            />
                        ),
                        generateStyles(Boolean(option.successMessage)),
                    );
                }
            },
        );

        setTimeout(() => {
            dispatch(reducerSetRequestStatus(null));
            dispatch(reducerSetRequestStatusMessage(null));
        }, 5000);
    }, [dispatch, requestStatus, requestStatusMessage]);

    useEffect(() => {
        if (!selectContactById) {
            setIsPending(true);
            dispatch(actionGetServiceTypes(actualLimit, offset, {})).then(() => {
                setIsPending(false);
            });
            dispatch(actionGetServiceTypesSelect());
        }
    }, [selectContactById, id, dispatch, actualLimit, offset]);

    const displayedAvailableBtns = filteredAvailableButtons
        ?.slice(-(overflowedBtnsCount as number))
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    const displayedHeadBtns = filteredAvailableButtons
        ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    const handleFilterInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        if (value === '') {
            const updatedInputValues = { ...filterInputValues };
            delete updatedInputValues[name as keyof ICoefficientFilterInputValues];

            dispatch(reducerCoefficientFilterInputValues(updatedInputValues));
        } else {
            dispatch(
                reducerCoefficientFilterInputValues({
                    ...filterInputValues,
                    [name]: value,
                }),
            );
        }

        setIsInputChange(true);
    };

    const handleFilterKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && id) {
            resetPages();
            fetchCoefficients(1, actualLimit);
            setIsInputChange(false);
        }
    };

    const parseFilterDate = (dateStr?: string | null): Date | null => {
        if (!dateStr) {
            return null;
        }

        const parsed = parse(dateStr, 'yyyy-MM-dd', new Date());

        return isValid(parsed) ? parsed : null;
    };

    const isValidDisplayDate = (date: Date | null): boolean => {
        if (!date) {
            return false;
        }

        return isValid(date) && format(date, 'dd.MM.yyyy').length === 10;
    };

    const validateCoefficientInput = (
        values: IAddContractInputValue,
    ): string | null => {
        if (!values.project) {
            return 'Необходимо выбрать проект';
        }

        if (!values.coefficient?.trim()) {
            return 'Необходимо указать коэффициент';
        }

        if (!values.startDate) {
            return 'Необходимо указать дату начала действия';
        }

        const coefficientValue = parseFloat(values.coefficient.replace(',', '.'));

        if (Number.isNaN(coefficientValue) || coefficientValue <= 0) {
            return 'Коэффициент должен быть больше 0';
        }

        if (!isValidDisplayDate(values.startDate)) {
            return 'Дата начала действия должна быть в формате ДД.ММ.ГГГГ';
        }

        if (values.endDate) {
            if (!isValidDisplayDate(values.endDate)) {
                return 'Дата окончания действия должна быть в формате ДД.ММ.ГГГГ';
            }

            if (values.endDate < values.startDate) {
                return 'Дата окончания действия не может быть меньше даты начала действия';
            }
        }

        return null;
    };

    const showCoefficientValidationError = (message: string) => {
        dispatch(reducerSetRequestStatusMessage(message));
        dispatch(reducerSetRequestStatus('validationError'));
    };

    const formatDisplayDate = (dateStr?: string | null): string => {
        const parsed = parseFilterDate(dateStr);

        return parsed ? format(parsed, 'dd.MM.yyyy') : '';
    };

    const handleFilterDateChange = (
        date: Date | null,
        name: 'fromDate' | 'toDate',
    ) => {
        const updatedInputValues = { ...filterInputValues };

        if (!date) {
            delete updatedInputValues[name];
        } else {
            updatedInputValues[name] = format(date, 'yyyy-MM-dd');
        }

        dispatch(reducerCoefficientFilterInputValues(updatedInputValues));

        if (id) {
            resetPages();
            fetchCoefficients(1, actualLimit);
        }

        setIsInputChange(false);
    };

    const handleProjectFilterChange = (event: { value: number | string; label: string }) => {
        const updatedInputValues = { ...filterInputValues };

        if (event.value === '') {
            delete updatedInputValues.project;
        } else {
            updatedInputValues.project = {
                value: event.value as number,
                label: event.label,
            };
        }

        dispatch(reducerCoefficientFilterInputValues(updatedInputValues));
        if (id) {
            resetPages();
            fetchCoefficients(1, actualLimit);
        }
        setIsInputChange(false);
    };

    const handleActivatedFilterChange = (event: { value: string; label: string }) => {
        const updatedInputValues = { ...filterInputValues };

        if (event.value === '') {
            delete updatedInputValues.activated;
        } else {
            updatedInputValues.activated = event.value;
        }

        dispatch(reducerCoefficientFilterInputValues(updatedInputValues));
        if (id) {
            resetPages();
            fetchCoefficients(1, actualLimit);
        }
        setIsInputChange(false);
    };

    const handleAddButton = () => {
        const validationError = validateCoefficientInput(addContractInputValues);

        if (validationError) {
            showCoefficientValidationError(validationError);
            return;
        }

        dispatch(reducerSetRequestStatus(null));
        dispatch(reducerSetRequestStatusMessage(null));
        void dispatch(
            actionAddCoefficient({
                ...addContractInputValues,
                contract: id,
            }),
        ).then((isSuccess) => {
            if (isSuccess) {
                setAddContractInputValues(initialAddInputState);
            }
        });
    };

    const handleSaveButton = () => {
        const validationError = validateCoefficientInput(editContractInputValues);

        if (validationError) {
            showCoefficientValidationError(validationError);
            return;
        }

        dispatch(reducerSetRequestStatus(null));
        dispatch(reducerSetRequestStatusMessage(null));
        dispatch(
            actionEditCoefficient({
                ...editContractInputValues,
                contract: id,
            }),
        );
        setEditRowId(null);
    };

    const handleEditRowButton = (contractId: number) => {
        setEditRowId(contractId);
        if (id) {
            const editableObject = list[id].find(
                (el: any) => el.contractBudget.id === contractId,
            );
            setEditContractInputValues({
                project: {
                    value: editableObject.project.id,
                    label: simplifiedProjectsById[editableObject.project.id],
                },
                pos: editableObject.pos
                    ? {
                        value: editableObject.pos.id,
                        label: editableObject.pos.name,
                    }
                    : null,
                coefficient: String(editableObject.coefficient),
                startDate: parseFilterDate(editableObject.startDate),
                endDate: parseFilterDate(editableObject.endDate),
                contractId,
            });
        }
    };

    const handleCancelButton = () => {
        setEditContractInputValues(initialEditInputState);
        setEditRowId(null);
    };

    const handleDeleteButton = (contractId: number) => {
        dispatch(
            actionDeleteCoefficient({
                contractId,
                contract: id,
            }),
        );
        setEditRowId(null);
    };

    function getContractId() {
        return parseInt(id ? id : '0');
    }

    const checkboxList = (check: boolean) => {
        const updatedCheckedRows = coefficientsList.reduce(
            (acc: { [key: number]: boolean }, el: any) => {
                acc[el.contractBudget.id] = check;
                return acc;
            },
            {},
        );
        setSelectedCoefficientIds(formatReports(updatedCheckedRows));
        setIsCheckedRows(updatedCheckedRows);
    };

    const handleHeaderCheckboxChange = () => {
        setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
        if (isHeaderCheckboxChecked) {
            checkboxList(false);
        }
    };

    const handleActivateButton = () => {
        if (!hasSelectedCoefficients) {
            dispatch(reducerSetRequestStatus('noSelection'));
            return;
        }

        dispatch(
            actionActivateCoefficients({
                contractId: getContractId(),
                ids: selectedCoefficientIds.map((item) => item.id),
            }),
        );
        checkboxList(false);
        setIsHeaderCheckboxChecked(false);
    };

    const handleBulkDeleteButton = () => {
        if (!hasSelectedCoefficients) {
            dispatch(reducerSetRequestStatus('noSelection'));
            return;
        }

        dispatch(
            actionBulkDeleteCoefficients({
                contractId: getContractId(),
                ids: selectedCoefficientIds.map((item) => item.id),
            }),
        );
        checkboxList(false);
        setIsHeaderCheckboxChecked(false);
    };

    const handleRowCheckboxChange = (contractBudgetId: number) => {
        setIsCheckedRows((prevCheckedRows) => ({
            ...prevCheckedRows,
            [contractBudgetId]: !prevCheckedRows[contractBudgetId],
        }));

        const updatedSelectedCoefficients = formatReports({
            ...isCheckedRows,
            [contractBudgetId]: !isCheckedRows[contractBudgetId],
        });
        setIsHeaderCheckboxChecked(
            updatedSelectedCoefficients.length === coefficientsList.length,
        );
        setSelectedCoefficientIds(updatedSelectedCoefficients);
    };

    useEffect(() => {
        checkboxList(false);
        setIsHeaderCheckboxChecked(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coefficientsList]);

    useEffect(() => {
        if (isHeaderCheckboxChecked && coefficientsList.length) {
            checkboxList(isHeaderCheckboxChecked);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isHeaderCheckboxChecked, coefficientsList]);

    const renderCoefficientFormCells = (
        values: IAddContractInputValue,
        onChange: (updatedValues: IAddContractInputValue) => void,
        coefficientInputName: string,
    ) => (
        <>
            <td>
                <div className='multiselect__filter_block'>
                    <Select
                        style={{ height: '45px' }}
                        options={simplifiedProjectsOptions}
                        propsChange={(event: { value: number; label: string }) => {
                            onChange({
                                ...values,
                                project: {
                                    value: event.value,
                                    label: event.label,
                                },
                            });
                        }}
                        value={values.project}
                        placeholder='Проект'
                        className='users__filter'
                        name='desktop'
                        isShowPlaceholder={true}
                        span='Проект'
                    />
                </div>
            </td>
            <td>
                <div className='multiselect__filter_block'>
                    <Select
                        style={{ height: '45px' }}
                        options={budgetPosesOptions}
                        propsChange={(event: { value: number; label: string }) => {
                            onChange({
                                ...values,
                                pos: {
                                    value: event.value,
                                    label: event.label,
                                },
                            });
                        }}
                        value={values.pos}
                        placeholder='ТТ'
                        className='users__filter'
                        name='pos'
                        isShowPlaceholder={true}
                        span='ТТ'
                        isSearchable={true}
                    />
                </div>
            </td>
            <td>
                <div className='filter__block filter__block--max-height'>
                    <input
                        name={coefficientInputName}
                        onChange={(event) => {
                            onChange({
                                ...values,
                                coefficient: event.target.value,
                            });
                        }}
                        placeholder=' '
                        type='number'
                        value={values.coefficient}
                    />
                    <label>Коэффициент</label>
                </div>
            </td>
            <td>
                <div className='filter__date-picker filter__block--max-height'>
                    <DatePicker
                        calendarClassName='filter__date-picker__calendar'
                        dateFormat='dd.MM.yyyy'
                        locale={ru}
                        placeholderText='Дата начала действия'
                        selected={values.startDate}
                        onChange={(date) => {
                            onChange({
                                ...values,
                                startDate: date,
                            });
                        }}
                    />
                </div>
            </td>
            <td>
                <div className='filter__date-picker filter__block--max-height'>
                    <DatePicker
                        calendarClassName='filter__date-picker__calendar'
                        dateFormat='dd.MM.yyyy'
                        locale={ru}
                        placeholderText='Дата окончания действия'
                        selected={values.endDate}
                        onChange={(date) => {
                            onChange({
                                ...values,
                                endDate: date,
                            });
                        }}
                    />
                </div>
            </td>
        </>
    );

    return (
        <div className='App'>
            <Sidebar />
            <SectionContent
                buttonsContainerRef={buttonsContainerRef}
                headBlockChildren={displayedHeadBtns}
                isOpenGroupBtn={isOpenGroupBtn}
                availableButtons={displayedAvailableBtns}
                title={selectContactById && id && selectContactById[id]}
                pageName='contractsInfo'
                section='Контракт'
            >
                {(claims.includes('admin') || claims.includes('contracts:budget:coefficient:list'))
                    && <div className='content__main'>
                        {/* <Link to={`/contracts/${id}/info`} className='tab'>
                        <div className='buttons__btn  --active'>Коэффициенты</div>
                    </Link> */}
                        <div
                            className={clsx(
                                isOpenSidebar && 'btns_active',
                                !isOpenSidebar && 'btns_close',
                                'btns',
                            )}
                        >
                            {canActivateCoefficients && (
                                <div
                                    className={clsx(
                                        'tab',
                                        'buttons__btn',
                                        hasSelectedCoefficients && '--active',
                                        styles.bulkActionBtn,
                                        !hasSelectedCoefficients && styles.bulkActionBtnDisabled,
                                    )}
                                    onClick={handleActivateButton}
                                >
                                    Активировать
                                </div>
                            )}
                            {canEditCoefficients && (
                                <div
                                    className={clsx(
                                        'tab',
                                        'buttons__btn',
                                        hasSelectedCoefficients && '--active',
                                        styles.bulkActionBtn,
                                        !hasSelectedCoefficients && styles.bulkActionBtnDisabled,
                                    )}
                                    onClick={handleBulkDeleteButton}
                                >
                                    Удалить
                                </div>
                            )}
                        </div>

                        <div className='loader__wrapper'>
                            {isPending && <Loader />}
                        </div>
                        {requestStatus && (
                            <Toaster
                                position='top-center'
                                toastOptions={{
                                    duration: 5000,
                                }}
                            />
                        )}
                        <div className='table__wrapper'>
                            <table className='flexible-table'>
                                <thead className='table__header__filters'>
                                    <tr>
                                        {canBulkSelect && (
                                            <th className={styles.checkboxBlock}>
                                                <input
                                                    onChange={handleHeaderCheckboxChange}
                                                    checked={isHeaderCheckboxChecked}
                                                    type='checkbox'
                                                />
                                            </th>
                                        )}
                                        <th>
                                            <div className='multiselect__filter_block'>
                                                <Select
                                                    style={{ height: '40px' }}
                                                    options={projectFilterOptions}
                                                    propsChange={(event: {
                                                        value: number | string;
                                                        label: string;
                                                    }) => handleProjectFilterChange(event)}
                                                    value={
                                                        filterInputValues.project
                                                            ? filterInputValues.project
                                                            : projectFilterOptions[0]
                                                    }
                                                    placeholder='Проект'
                                                    className='users__filter'
                                                    name='desktop'
                                                    isShowPlaceholder={!filterInputValues.project}
                                                    span='Проект'
                                                />
                                            </div>
                                        </th>
                                        <th>
                                            <div className='filter__block'>
                                                <input
                                                    defaultValue={
                                                        filterInputValues.posSearch || ''
                                                    }
                                                    onChange={handleFilterInputChange}
                                                    onKeyPress={handleFilterKeyPress}
                                                    autoComplete='off'
                                                    placeholder=' '
                                                    name='posSearch'
                                                    type='text'
                                                />
                                                <label>ТТ</label>
                                            </div>
                                        </th>
                                        <th>Коэффициент</th>
                                        <th>
                                            <div className='filter__date-picker'>
                                                <DatePicker
                                                    calendarClassName='filter__date-picker__calendar'
                                                    dateFormat='dd.MM.yyyy'
                                                    locale={ru}
                                                    placeholderText='Дата начала действия'
                                                    selected={parseFilterDate(filterInputValues.fromDate)}
                                                    autoComplete='off'
                                                    name='fromDate'
                                                    onChange={(date) =>
                                                        handleFilterDateChange(date, 'fromDate')
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th>
                                            <div className='filter__date-picker'>
                                                <DatePicker
                                                    calendarClassName='filter__date-picker__calendar'
                                                    dateFormat='dd.MM.yyyy'
                                                    locale={ru}
                                                    placeholderText='Дата окончания действия'
                                                    selected={parseFilterDate(filterInputValues.toDate)}
                                                    autoComplete='off'
                                                    name='toDate'
                                                    onChange={(date) =>
                                                        handleFilterDateChange(date, 'toDate')
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th>
                                            <div className='filter__number_block'>
                                                <Select
                                                    defaultValue={
                                                        filterInputValues.activated !== undefined
                                                            ? activatedFilterOptions.find(
                                                                (option) =>
                                                                    option.value === filterInputValues.activated,
                                                            )
                                                            : activatedFilterOptions[0]
                                                    }
                                                    isShowPlaceholder={
                                                        filterInputValues.activated !== undefined
                                                    }
                                                    propsChange={(event: {
                                                        value: string;
                                                        label: string;
                                                    }) => handleActivatedFilterChange(event)}
                                                    options={activatedFilterOptions}
                                                    className='users__filter'
                                                    placeholder='Активирована'
                                                    name='activated'
                                                    span='Активирована'
                                                />
                                            </div>
                                        </th>
                                        {canEditCoefficients && (
                                            <>
                                                <th></th>
                                                <th></th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {coefficientsList.map((el: any) => (
                                        <tr
                                            className={clsx(
                                                'active__link_tr',
                                                el.activated === false && 'red__row',
                                                editRowId === el.contractBudget.id && 'table_contracts__tr',
                                            )}
                                            key={`${el.contractBudget.id}`}
                                        >
                                            {canBulkSelect && (
                                                <td>
                                                    <input
                                                        onChange={() =>
                                                            handleRowCheckboxChange(
                                                                el.contractBudget.id,
                                                            )
                                                        }
                                                        checked={
                                                            (isCheckedRows &&
                                                                isCheckedRows[
                                                                el.contractBudget.id
                                                                ]) ||
                                                            false
                                                        }
                                                        type='checkbox'
                                                        disabled={editRowId === el.contractBudget.id}
                                                    />
                                                </td>
                                            )}
                                            {editRowId === el.contractBudget.id
                                                ? renderCoefficientFormCells(
                                                    editContractInputValues,
                                                    (updatedValues) => {
                                                        setEditContractInputValues({
                                                            ...updatedValues,
                                                            contractId: editContractInputValues.contractId,
                                                        });
                                                    },
                                                    'editCoefficient',
                                                )
                                                : (
                                                    <>
                                                        <td>
                                                            {simplifiedProjectsById &&
                                                                simplifiedProjectsById[el.project.id]}
                                                        </td>
                                                        <td>{el.pos?.name || '—'}</td>
                                                        <td>{el.coefficient}</td>
                                                        <td>{formatDisplayDate(el.startDate)}</td>
                                                        <td>{formatDisplayDate(el.endDate) || '—'}</td>
                                                    </>
                                                )}
                                            <td>
                                                {el.activated ? 'Да' : 'Нет'}
                                            </td>
                                            {canEditCoefficients && (
                                                <>
                                                    <td>
                                                        {editRowId === el.contractBudget.id && (
                                                            <div
                                                                className='buttons__action'
                                                                onClick={handleSaveButton}
                                                            >
                                                                <img
                                                                    className='customers__icon'
                                                                    src={Checkbox}
                                                                    alt='Сохранить'
                                                                />
                                                                <span className='buttons__action__green'>
                                                                    Сохранить
                                                                </span>
                                                            </div>
                                                        )}

                                                        {editRowId !== el.contractBudget.id && !editRowId && (
                                                            <div
                                                                className='buttons__action'
                                                                onClick={() =>
                                                                    handleEditRowButton(el.contractBudget.id)
                                                                }
                                                            >
                                                                <img
                                                                    className='customers__icon'
                                                                    src={Edit}
                                                                    alt='Редактировать'
                                                                />
                                                                <span>
                                                                    Редактировать
                                                                </span>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {editRowId === el.contractBudget.id && (
                                                            <div
                                                                className='buttons__action'
                                                                onClick={handleCancelButton}
                                                            >
                                                                <img
                                                                    className='customers__icon'
                                                                    src={Delete}
                                                                    alt='Отменить'
                                                                />
                                                                <span>Отменить</span>
                                                            </div>
                                                        )}
                                                        {editRowId !== el.contractBudget.id && !editRowId && (
                                                            <div
                                                                className='buttons__action'
                                                                onClick={() =>
                                                                    handleDeleteButton(el.contractBudget.id)
                                                                }
                                                            >
                                                                <img
                                                                    className='customers__icon'
                                                                    src={Delete}
                                                                    alt='Удалить'
                                                                />
                                                                <span>Удалить</span>
                                                            </div>
                                                        )}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                    {!editRowId && canEditCoefficients && (
                                        <tr className='table_contracts__tr'>
                                            {canBulkSelect && <td></td>}
                                            {renderCoefficientFormCells(
                                                addContractInputValues,
                                                setAddContractInputValues,
                                                'addCoefficient',
                                            )}
                                            <td></td>
                                            <td colSpan={2}>
                                                <button
                                                    onClick={handleAddButton}
                                                    className='table-button'
                                                >
                                                    Добавить коэффициент
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className='pagination'>
                            <div className='pagination__count'>Всего: {count}</div>
                            <div className='pagination__str'>
                                <span>Отображать строки</span>
                                <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
                            </div>
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                setStartPage={setStartPage}
                                handleChange={handleChange}
                                currentPage={currentPage}
                                startPage={startPage}
                                count={count}
                                limit={actualLimit}
                                pageName='userReports'
                            />
                        </div>
                    </div>}
            </SectionContent>
        </div>
    );
};

export default AdminContractsInfoSection;